import ActionType from 'actions/ActionType'

export default (state = { value: [], initialValue: [] }, action) => {
	switch (action.type) {
		case ActionType.Contacts.HANDLE_GROUP_CHANGE:
			return { ...state, value: action.payload }
		case ActionType.Contacts.RECEIVE_CONTACT:
			if (action.payload) {
				const arr = action.payload.contact_groups
					? Object.values(action.payload.contact_groups).map((group) => ({
							groupID: group.id,
							value: group.id,
							label: `${group.name}`,
							key: `${group.id}GroupSelectValue`,
					  }))
					: []
				return {
					value: arr,
					initialValue: arr,
				}
			}
			return { value: [], initialValue: [] }
		case ActionType.Contacts.GET_SUCCESS:
			if (action.payload) {
				const arr = action.payload.contact_groups
					? Object.values(action.payload.contact_groups).map((group) => ({
							groupID: group.id,
							value: group.id,
							label: `${group.name}`,
							key: `${group.id}GroupSelectValue`,
					  }))
					: []
				return {
					value: arr,
					initialValue: arr,
				}
			}
			return { value: [], initialValue: [] }
		case ActionType.Contacts.HANDLE_GROUP_SUGGESTION_CLICK:
			return { ...state, value: [...state.value, action.payload] }
		default:
			return state
	}
}
